<template>
  <VBtnToggle
    v-model="selection"
    divided
    class="custom-toggle"
    density="compact"
    variant="flat"
    mandatory
    @update:model-value="handleSwitchChange"
  >
    <VBtn
      :value="DrinkTimeMode.DAY"
      class="custom-btn"
      :variant="selection === DrinkTimeMode.DAY ? 'flat' : 'text'"
    >
      <VIcon size="16">mdi-white-balance-sunny</VIcon>
    </VBtn>
    <VBtn
      :value="DrinkTimeMode.NIGHT"
      class="custom-btn"
      :variant="selection === DrinkTimeMode.NIGHT ? 'elevated' : 'text'"
    >
      <VIcon size="16">mdi-weather-night</VIcon>
    </VBtn>
  </VBtnToggle>
</template>

<style scoped>
.custom-toggle {
  border-radius: 9999px;
  background-color: #6a6a6acc;
  padding: 2px;
  width: fit-content;
}

.custom-btn {
  min-width: unset;
  padding: 4px 8px;
  border-radius: 9999px !important;
  transition: background-color 0.2s ease;
  font-size: 13px;
}
</style>

<script setup lang="ts">
import { DrinkTimeMode } from "@/views/menus/drinks/types/drinks";
import { onMounted, ref } from "vue";

const props = defineProps<{
  timeMode: DrinkTimeMode;
  handleSwitchChange: (timeMode: DrinkTimeMode) => void;
}>();

const selection = ref();

onMounted(() => {
  selection.value = props.timeMode || DrinkTimeMode.NIGHT;
});
</script>
